<template>
<div id="scene-container" ref="sceneContainer">
    <div id="ui-container" ref="uiContainer">
        <ArtifactDetails ref="artifact" v-bind:iden="itemId" @button="displayModal" />
        <Gate3dMetadata ref="gateMeta" v-bind:gateName="this.$router.currentRoute.name" />
    </div>
</div>
</template>

<script>
/*TODO: before deploying - import only necessary elements like in GateElements.js*/
import * as THREE from 'three'
import {
    GLTFLoader
} from 'three/examples/jsm/loaders/GLTFLoader'
/*
import Stats from 'stats.js'
*/
import GateElements from "../components/GateElements";
import ArtifactDetails from "@/components/ArtifactDetails";
import Gate3dMetadata from "@/components/Gate3dMetadata";
import {
    Audio
} from "three/src/audio/Audio";
import {
    AudioLoader
} from "three/src/loaders/AudioLoader";
import {
    AudioListener
} from "three/src/audio/AudioListener";
import {
    bus
} from "@/main";
import {
    Quaternion
} from "three";


export default {
    name: 'Yellow',
    components: {
        ArtifactDetails,
        Gate3dMetadata
    },
    data() {
        return {
            container: null,
            scene: null,
            camera: null,
            startedInteraction: false,
            controls: null,
            renderer: null,
            listener: null,
            ambience: [],
            ambiencePath: [
                '/audio/gates/Yellow/Yellow_Atmos.mp3',
                '/audio/gates/Yellow/Yellow_MusicalLoop.mp3',
            ],
            audioContexts: [],
            biquadFilters: [],
            /* stats: null, */
            modalVisible: false,
            itemId: null,
            sceneObjects: [{
                main_gates: {
                    object: null,
                    id: 31,
                },
                benders: {
                    object: null,
                    id: 32,
                },
                water_spout: {
                    object: null,
                    id: 33,
                },
                provisions: {
                    object: null,
                    id: 34,
                },
                typewriter: {
                    object: null,
                    id: 35,
                },
                papers: {
                    object: null,
                    id: 36,
                },
                glasses: {
                    object: null,
                    id: 37,
                },
                books: {
                    object: null,
                    id: 38,
                },
                cups_plates: {
                    object: null,
                    id: 39,
                },
                guitar: {
                    object: null,
                    id: 40,
                },
                sleeping_bag: {
                    object: null,
                    id: 41,
                },
                shit_pit: {
                    object: null,
                    id: 42,
                },
                teapot: {
                    object: null,
                    id: 43,
                },
                benders2: {
                    object: null,
                    id: 44,
                },
                songsheet_sarah: {
                    object: null,
                    id: 45,
                },
                songsheet_here: {
                    object: null,
                    id: 46,
                },
                tipiyellow: {
                    object: null,
                    id: 47,
                },
                bushes: {
                    object: null,
                    id: 48,
                },
                sun_yellow: {
                    object: null,
                    id: 49,
                },

            }],

            lastTouchPos: null,
            clock: null,
            targetRotation: null,
        }
    },
    methods: {
        async init() {
            // set container
            this.container = this.$refs.sceneContainer

            /*
                            // add stats
                            this.stats = new Stats()
                            this.container.appendChild(this.stats.dom)
            */

            // clock needed for rotation slerp
            this.clock = new THREE.Clock()

            // add camera
            this.camera = GateElements.createFirstPersonCamera()


            // create scene
            this.scene = new THREE.Scene()
            this.scene.background = new THREE.Color('#D7E8FA')

            // add lights
            const ambientLight = new THREE.HemisphereLight(
                0xffffff, // bright sky color
                0x222222, // dim ground color
                1 // intensity
            )
            const mainLight = new THREE.DirectionalLight(0xffffff, 4.0)
            mainLight.position.set(-10, 10, 10)
            this.scene.add(ambientLight, mainLight)

            // add controls
            this.controls = GateElements.createFirstPersonControls(this.camera, this.container);

            // create renderer
            this.renderer = GateElements.createRenderer()
            this.container.appendChild(this.renderer.domElement)

            // set the mouse & raycaster
            this.mouse = new THREE.Vector2()
            this.raycaster = new THREE.Raycaster();


            // load and add an object to the scene
            var sceneObject = await this.loadGeometryAsync()
            this.scene.add(sceneObject.scene)

            //TODO: uncomment once new 3d object loaded
            this.assignObjects()

            //audio part
            this.listener = new AudioListener()
            this.camera.add(this.listener)

            await this.loadPlayAmbienceAsync(this.ambiencePath[0])
            await this.loadPlayAmbienceAsync(this.ambiencePath[1])

            this.prepareFilters(0, 22000)
            this.prepareFilters(1, 22000)

        },

        render() {
            this.renderer.render(this.scene, this.camera)
            /*                this.stats.update()*/

        },

        animate() {
            this.renderer.setAnimationLoop(() => {
                this.render()
                if (!this.startedInteraction) this.camera.rotation.y -= 0.0005

            })
            this.establishListeners()
        },

        stopAnimating() {
            this.renderer.setAnimationLoop(null);
        },

        establishListeners() {
            window.addEventListener('resize', this.onWindowResize.bind(this), false)
            window.addEventListener('mousedown', this.onMouseClick.bind(this), false)

            window.addEventListener('touchmove', this.onTouchMove.bind(this), false);

        },

        onWindowResize() {
            // set aspect ratio to match the new browser window aspect ratio
            this.camera.aspect = window.innerWidth / window.innerHeight;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(window.innerWidth, window.innerHeight);
            this.controls.handleResize();
        },

        loadGeometryAsync() {
            return new Promise((resolve) => {
                const loader = new GLTFLoader()
                loader.load(
                    '/models/gate_yellow.glb',
                    model => {
                        //console.log('Yellow: loading model ' + model)
                        resolve(model)
                    },
                    undefined,
                    undefined
                )
            })
        },

        assignObjects() {
            this.sceneObjects[0].main_gates.object = this.scene.getObjectByName('Main_Gates');
            this.sceneObjects[0].benders.object = this.scene.getObjectByName('Benders');
            this.sceneObjects[0].water_spout.object = this.scene.getObjectByName('Water_Spout');
            this.sceneObjects[0].provisions.object = this.scene.getObjectByName('Provisions');
            this.sceneObjects[0].typewriter.object = this.scene.getObjectByName('Typewriter');
            this.sceneObjects[0].papers.object = this.scene.getObjectByName('Papers');
            this.sceneObjects[0].glasses.object = this.scene.getObjectByName('Glasses');
            this.sceneObjects[0].books.object = this.scene.getObjectByName('Books');
            this.sceneObjects[0].cups_plates.object = this.scene.getObjectByName('Cups_Plates');
            this.sceneObjects[0].guitar.object = this.scene.getObjectByName('Guitar');
            this.sceneObjects[0].sleeping_bag.object = this.scene.getObjectByName('Sleeping_Bag');
            this.sceneObjects[0].shit_pit.object = this.scene.getObjectByName('Shit_Pit');
            this.sceneObjects[0].teapot.object = this.scene.getObjectByName('Teapot');
            this.sceneObjects[0].benders2.object = this.scene.getObjectByName('Benders2');
            this.sceneObjects[0].songsheet_sarah.object = this.scene.getObjectByName('Songsheet_Sarah');
            this.sceneObjects[0].songsheet_here.object = this.scene.getObjectByName('Songsheet_Here');
            this.sceneObjects[0].tipiyellow.object = this.scene.getObjectByName('Tipiyellow');
            this.sceneObjects[0].bushes.object = this.scene.getObjectByName('Bushes');
            this.sceneObjects[0].sun_yellow.object = this.scene.getObjectByName('Sun_Yellow');
        },

        loadPlayAmbienceAsync(trackPath) {
            let tempAmbience = new Audio(this.listener)
            this.ambience.push(tempAmbience)
            return new Promise((resolve) => {
                const loader = new AudioLoader()
                loader.load(
                    trackPath,
                    buffer => {
                        tempAmbience.setBuffer(buffer)
                        tempAmbience.setLoop(true)
                        tempAmbience.setVolume(0.5)
                        tempAmbience.play()
                        resolve(buffer)
                    },
                    undefined,
                    undefined
                )
            })
        },

        prepareFilters(index, targetValue){
          this.audioContexts.push(this.ambience[index].context)
          this.biquadFilters.push(this.audioContexts[index].createBiquadFilter())
          this.biquadFilters[index].type = "lowpass"
          this.ambience[index].setFilter(this.biquadFilters[index])
          this.biquadFilters[index].frequency.setValueAtTime(targetValue, this.audioContexts[index].currentTime);
        },

        onTouchMove(event) {
            const delta = this.clock.getDelta();
            const step = 3 * delta
            if (event.touches[0].clientX > this.lastTouchPos) {
                this.targetRotation = this.camera.rotation.y += 0.035
            } else {
                this.targetRotation = this.camera.rotation.y -= 0.035
            }
            if (this.camera.rotation.y !== this.targetRotation) {

                let newRot = new Quaternion(this.camera.rotation.x, this.camera.rotation.y, this.camera.rotation.z)
                this.camera.quaternion.slerp(newRot, step)
            }
            this.lastTouchPos = event.touches[0].clientX
        },

        onMouseClick(event) {
            if (!this.startedInteraction) this.startedInteraction = true

            if (this.modalVisible) return

            this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
            this.raycaster.setFromCamera(this.mouse, this.camera);

            let intersects = this.raycaster.intersectObjects(this.scene.children, true);

            if (intersects.length > 0) {
                {
                    switch (intersects[0].object) {
                        case this.sceneObjects[0].main_gates.object:
                            this.itemId = this.sceneObjects[0].main_gates.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].benders.object:
                            this.itemId = this.sceneObjects[0].benders.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].water_spout.object:
                            this.itemId = this.sceneObjects[0].water_spout.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].provisions.object:
                            this.itemId = this.sceneObjects[0].provisions.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].typewriter.object:
                            this.itemId = this.sceneObjects[0].typewriter.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].papers.object:
                            this.itemId = this.sceneObjects[0].papers.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].glasses.object:
                            this.itemId = this.sceneObjects[0].glasses.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].books.object:
                            this.itemId = this.sceneObjects[0].books.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].cups_plates.object:
                            this.itemId = this.sceneObjects[0].cups_plates.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].guitar.object:
                            this.itemId = this.sceneObjects[0].guitar.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].sleeping_bag.object:
                            this.itemId = this.sceneObjects[0].sleeping_bag.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].shit_pit.object:
                            this.itemId = this.sceneObjects[0].shit_pit.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].teapot.object:
                            this.itemId = this.sceneObjects[0].teapot.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].benders2.object:
                            this.itemId = this.sceneObjects[0].benders2.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].songsheet_sarah.object:
                            this.itemId = this.sceneObjects[0].songsheet_sarah.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].songsheet_here.object:
                            this.itemId = this.sceneObjects[0].songsheet_here.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].tipiyellow.object:
                            this.itemId = this.sceneObjects[0].tipiyellow.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].bushes.object:
                            this.itemId = this.sceneObjects[0].bushes.id
                            this.displayModal();
                            break;
                        case this.sceneObjects[0].sun_yellow.object:
                            this.itemId = this.sceneObjects[0].sun_yellow.id
                            this.displayModal();
                            break;
                        default:
                            break;
                    }
                }
            }
        },

        displayModal() {
            this.$refs.artifact.toggleVisibility(this.itemId)
            setTimeout(this.revolveModal.bind(this), 150)
        },

        revolveModal() {
            this.modalVisible = !this.modalVisible

            if (!this.modalVisible){
              this.biquadFilters[0].frequency.setValueAtTime(22000, this.audioContexts[0].currentTime);
              this.biquadFilters[1].frequency.setValueAtTime(22000, this.audioContexts[1].currentTime);
            }
            else{
              this.biquadFilters[0].frequency.setValueAtTime(800, this.audioContexts[1].currentTime);
              this.biquadFilters[0].frequency.setValueAtTime(800, this.audioContexts[1].currentTime);
            }
        },

        disableController(valueReceived) {
            this.controls.isThreeDimensionOnly(valueReceived)
        },
    },

    computed: {
        collectables() {
            return this.$store.getters.collectables;
        }
    },

    mounted() {
        this.init().then(() => this.animate())
    },

    created() {
        bus.$on('sliderOff', this.disableController);
    },

    beforeDestroy() {
        bus.$off('sliderOff');
        this.stopAnimating()
        for (let i = 0; i < this.ambience.length; i++) {
            this.ambience[i].pause()
        }
    },
}
</script>

<style scoped>
#scene-container {
    height: 100%;
    overflow: hidden;
    z-index: 96;
}

#ui-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 97;
    /* pointer-events: auto; */
}
</style>
